function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,-4.7014)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.57433,10.0381)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.426,
    cy: 18.043,
    r: 4.574,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.57433,36.6582)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.426,
    cy: 18.043,
    r: 4.574,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.94px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.57433,63.2783)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.426,
    cy: 18.043,
    r: 4.574,
    style: {
      fill: "white",
      stroke: "white",
      strokeWidth: "4.94px"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.eaa36648a536e0d9283763957ac96754.svg";
export { ForwardRef as ReactComponent };